import React from 'react';
import { useStaticQuery, graphql } from "gatsby";

// Styles //
import "./label.scss";

interface labelProps {
    text: string;
    icon?: string;
}

const Label = (props: labelProps) => {
    const {text, icon } = props;

    const labelIcons = useStaticQuery(graphql`
        query LABELICONS {
            iconAudiolibro: allContentfulAsset(
                filter: { title: { eq: "icon-audiolibro" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconDigital: allContentfulAsset(
                filter: { title: { eq: "icon-digital" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconPodcast: allContentfulAsset(
                filter: { title: { eq: "icon-podcast" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconFisico: allContentfulAsset(
                filter: { title: { eq: "icon-fisico" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
        }
    `);

    const iconsObj: {[key: string]: string} = {
        "icon-audiolibro": labelIcons.iconAudiolibro.nodes[0].file.url,
        "icon-digital": labelIcons.iconDigital.nodes[0].file.url,
        "icon-podcast": labelIcons.iconPodcast.nodes[0].file.url,
        "icon-fisico": labelIcons.iconFisico.nodes[0].file.url,
    }

    return (
        <div className="a-label">
            {icon && <img src={iconsObj[icon]} alt={text} />}
            <span>{text}</span>
        </div>
    )
}

export default Label;